import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'wrapper', 'toggler' ]

  toggle(e) {
    e.preventDefault()
    if (this.wrapperTarget.classList.contains('sidebar-collapsed')) {
      this.wrapperTarget.classList.remove('sidebar-collapsed');
    } else {
      this.wrapperTarget.classList.add('sidebar-collapsed');
    } 
  }

}

